<template>
  <div class="warn">
    <headerMain></headerMain>
    <el-main>
      <div class="warn-list">
        <div class="title">消息中心</div>
        <div class="news-item-box">
          <div class="item-box">
            <div class="item" v-for="(item, index) in eventOptions" :key="index" :class="eventType == item.value ? 'active' : ''" @click="changeType(item)">
              <div :class="'font-color'+index">{{ item.label }}</div>
            </div>
          </div>
        </div>
        <div class="pro-info">
          <div class="right1">
            <span>报警类型：</span>
            <el-select v-model="eventType1" placeholder="请选择" @change="changeType1">
              <el-option v-for="item in eventOptions1" :key="item.id" :label="item.alarmDesc" :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="right">
            <el-input placeholder="请输入报警描述" v-model="searchInput" clearable> </el-input>
            <el-button type="primary" class="search" @click="search">搜索</el-button>
            <el-button class="return-btn" @click="returnUp">返回</el-button>
          </div>
        </div>
        <!-- <el-button class="return-btn" @click="returnUp">返回</el-button> -->
        <!-- <div class="pro-info">
          <div class="left">
            <span>报警类型：</span>
            <el-select v-model="value" placeholder="请选择报警类型">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="right">
            <el-input
              placeholder="请输入搜索内容"
              prefix-icon="el-icon-search"
              v-model="input2"
            >
            </el-input>
            <el-button type="primary" class="search">搜索</el-button>    
          </div>
        </div> -->
        <div class="table-box">
          <el-table :data="tableData" style="width: 100%;overflow:  auto;" :row-style="setRowStyle" @sort-change="changeTableSort">
            <el-table-column prop="status" align="right" width="20" label="">
              <template slot-scope="scope">
                <div class="type" v-if="(new Date(scope.row.alarmTime).getTime())>=(new Date().getTime() - 24 * 60 * 60 * 1000)&&(new Date().getTime()>=new Date(scope.row.alarmTime).getTime())"></div>
                <!-- <div v-if="scope.row.status===0">{{new Date().getTime() - 24 * 60 * 60 * 1000}}</div> -->
                <!--  class="type" <p>{{ scope.row.alarmValueType == 1 ? "告警" : "异常" }}</p>    new Date(-->
              </template>
            </el-table-column>
            <el-table-column type="index" align="left" label="编号" width="50">
            </el-table-column>
            <el-table-column prop="alarmTime" width="230" :sortable="'custom'" :sort-orders="['ascending', 'descending']" label="报警时间">
            </el-table-column>
            <el-table-column prop="projectName" width="200" label="所属项目">
            </el-table-column>
            <el-table-column prop="roomName" width="230" label="配电室">
            </el-table-column>
            <!-- <el-table-column
              prop="alarmType"
              width="150"
              :formatter="formatter"
              label="报警类型"
            >
            </el-table-column> -->
            <el-table-column prop="alarmDesc" label="报警描述">
            </el-table-column>
            <!-- <el-table-column prop="alarmTime" label="告警时间">
            </el-table-column> -->
            <el-table-column prop="edit" label="状态" width="120">
              <template slot-scope="scope">
                <div class="btn-out-box">
                  <el-tag :type="scope.row.status ? 'info' : 'warning'" @click="editselfHandle(scope)">{{ scope.row.status ? '已处理' : '待处理' }}</el-tag>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="m-t-lg" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" align="right" background :page-sizes="[10, 20, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
          <!-- <el-pagination background layout="prev, pager, next" :current-page.sync="currentPage" :total="total" @current-change="paginationHandle">
          </el-pagination> -->
        </div>
      </div>
    </el-main>
    <el-dialog :visible.sync="dialogVisible" width="600px" :close-on-click-modal="true">
      <!-- :append-to-body="false" -->
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- :modal-append-to-body="false" -->
    <el-dialog title="报警处理信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :modal-append-to-body="false">
      <div class="name">{{ alarmInfo.roomName }}</div>
      <div class="br"></div>
      <section>
        <!-- {{eventType}} -->
        <span class="label">报警描述：</span>
        <span class="info">{{ alarmInfo.alarmDesc }}</span>
      </section>
      <section>
        <span class="label">配电柜编号：</span>
        <span class="info inline">{{ alarmInfo.equipmentCode }}</span>
      </section>
      <section>
        <span class="label">报警时间：</span>
        <span class="info inline">{{ alarmInfo.alarmTime }}</span>
      </section>
      <div class="br"></div>
      <section>
        <p class="label mb10">确认人</p>
        <el-input placeholder="请输入" v-model="input2" :readonly="alarmInfo.status == 1" show-word-limit maxlength="50"> </el-input>
      </section>
      <section>
        <p class="label mb10">处理信息</p>
        <el-input type="textarea" :autosize=" { minRows: 2, maxRows: 5 }" :readonly="alarmInfo.status == 1" maxlength="1000" show-word-limit placeholder="请输入内容" v-model="textarea2">
        </el-input>
      </section>
      <section>
        <p class="label mb10">处理图片 <span class="tips-txt">*仅支持上传JPEG，PNG格式图像文件，最多支持9张</span></p>
         <el-upload ref="upload" v-if="alarmInfo.status == 0" action="https://jsonplaceholder.typicode.com/posts/"  accept=".jpg,.jpeg,.png" :on-exceed="handleExceed" list-type="picture-card" multiple :limit="9" :auto-upload="false" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :on-change="handleChange">
          <i class="el-icon-plus"></i>
        </el-upload>
        <div class="img-box" v-else>
          <!-- 切换到已处理，无法请求了数据但是界面没有变化 -->
          <div v-if="alarmInfo.imageUrls">
            <img :src="item" alt="" v-for="(item, index) in alarmInfo.imageUrls.split(',')" @click="open(item)" :key="index" />
          </div>
        </div>
        <!-- :modal-append-to-body="false" -->
      </section>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updata" v-if="alarmInfo.status == 0">提 交</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

// import {
//   this.$message
// } from 'element-ui';
import headerMain from "../components/headerMain";
import qs from "qs";
export default {
  name: "warn",
  data() {
    return {
      input2: "",
      searchInput: "",
      currentPage: 1,
      eventType1: "",
      eventType: "-1",
      total: 0,
      size: 10,
      tableData: [
        // {
        //   number: "1",
        //   projectName: "金电联",
        //   peidianshi: "总配",
        //   deviceType: "高压仪表",
        //   deviceNumber: "T1-3-5",
        //   deviceDescribe: "总配201",
        //   deviceAddress: "A区B栋207号C-2003配电室",
        //   warnDescribe: "电流三相电流降至0，疑似断路",
        //   warnType: "告警",
        //   date: "2020-10-05",
        //   isOpen: true,
        // },
      ],
      eventOptions: [
        {
          value: "-1",
          label: "全部",
        },
        {
          value: "0",
          label: "未处理",
        },
        {
          value: "1",
          label: "已处理",
        },
      ],
      projectIds: [],
      textarea2: "",
      fileList: [],
      orderBy: "",
      dialogFormVisible: false,
      alarmInfo: {},
      dialogImageUrl: "",
      dialogVisible: false,
      options: [
        {
          value: "0",
          label: "未处理",
        },
        {
          value: "1",
          label: "已处理",
        },
      ],
      eventOptions1: [
        // {
        //   value: "0",
        //   label: "全部",
        // },
        // {
        //   value: "1",
        //   label: "分闸",
        // },
        // {
        //   value: "2",
        //   label: "合闸",
        // },
        // {
        //   value: "3",
        //   label: "跳闸",
        // },
      ],
      userId: "",
      value: "",
    };
  },
  components: { headerMain },
  methods: {
    returnUp() {
      this.$router.go(-1);
    },
    setRowStyle({ row, rowIndex }) {
      let styleObj = {};
      // // console.log(row);
      // // console.log(rowIndex);
      // 已处理
      // if (row.status === 1) {
      //   styleObj.color = "rgba(51, 204, 141, 1)!important";
      //   return styleObj;
      //   // 未处理
      // } else if (row.status === 0) {
      //   styleObj.color = "#fc5959!important";
      //   return styleObj;
      //   // 全部
      // } else {
      //   styleObj.color = "#152139!important";
      //   return styleObj;
      // }
      // 已处理
      if (row.eventType === "1") {
        styleObj.color = "rgba(51, 204, 141, 1)!important";
        return styleObj;
        // 未处理
      } else if (row.eventType === "0") {
        styleObj.color = "#fc5959!important";
        return styleObj;
        // 全部
      } else {
        styleObj.color = "#152139!important";
        return styleObj;
      }
    },
    getAlarmType() {
      this.$http
        .post("bma-distribution-service/alarmConfig/searchAlarmConfigs")
        .then((res) => {
          if (res.data) {
            this.eventOptions1 = res.data;
            let newDate = {
              alarmType: "全部",
              alarmDesc: "全部",
              id: 0,
            };
            this.eventOptions1.unshift(newDate);
          }
        });
    },
    //选择指定列进行排序
    changeTableSort(column) {
      // console.log(column);
      var sortingType = column.order;
      this.currentPage = 1;
      //按照降序排序  下降
      if (sortingType == "descending") {
        this.orderBy = "desc";
        this.getProjectList();
        // this.tableData = this.tableData.sort((a, b) => b[fieldName] - a[fieldName]);
      }
      //按照升序排序  上升
      else if (sortingType == "ascending") {
        this.orderBy = "asc";
        this.getProjectList();
        // this.tableData = this.tableData.sort((a, b) => a[fieldName] - b[fieldName]);
      } else {
        this.orderBy = "asc";
        this.getProjectList();
      }
      // // console.log(this.tableData);
    },
    changeType(v) {
      this.currentPage = 1;
      this.eventType = v.value;
      this.getProjectList();
      // this.searchAlarmCountStatistics();
    },
    changeType1(v) {
      this.currentPage = 1;
      this.eventType1 = v;
      this.getProjectList();
      // this.searchAlarmCountStatistics();
      // alert('等待接口对接')
    },
    // 分页
    paginationHandle(e) {
      this.currentPage = e;
      this.getProjectUnHandleByUser();
    },
    formatter(row, column) {
      if (row.alarmType === 1) {
        return "告警";
      } else if (row.alarmType === 0) {
        return "异常";
      } else {
        return " ";
      }
    },
    editselfHandle(e) {
      this.alarmInfo = e.row;
     this.textarea2 = "", this.input2 = "", this.fileList = [];
      if (e.row.status == 1) {
        this.input2 = e.row.handler;
        this.textarea2 = e.row.handleResult;
      }
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.upload.clearFiles();
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getProjectUnHandleByUser();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getProjectUnHandleByUser();
    },
    updata() {
      if (this.textarea2 == "" || this.input2 == "") {
        this.$message.warning("请输入处理人和处理意见");
        return;
      }
      let formData = new FormData();
      for (var i = 0; i < this.fileList.length; i++) {
        // files[i] = this.fileList[i].raw;
        formData.append("multipartFiles", this.fileList[i].raw);
      }
      formData.append("alarmId", this.alarmInfo.id);
      formData.append("equipmentCode", this.alarmInfo.equipmentCode);
      formData.append("handleResult", this.textarea2);
      formData.append("handler", this.input2);
      // console.log(this.fileList);
      this.$http
        .post("bma-distribution-service/alarm/handleAlarm", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.code == 200) {
            let that=this
            this.$message.success("提交成功");
            that.getProjectUnHandleByUser();
            that.dialogFormVisible = false;
          } else {
            let _that=this
            this.$message.error("提交失败");
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getProjectUnHandleByUser();
    },
    getProjectList() {
      let that = this;
      that.projectIds = [];
      that.$http
        .post("bma-user-service/project/searchUserProjects", {
          userId: that.userId,
        })
        .then((res) => {
          res.data.forEach((item) => {
            that.projectIds.push(item.id);
          });
          // // console.log(that.projectIds);
          that.getProjectUnHandleByUser();
        });
    },
    getProjectUnHandleByUser() {
      // this.projectIds.join(",")
      this.$http
        .post("/bma-distribution-service/alarm/searchUnHandleAlarms", {
          projectIds: this.projectIds.join(","),
          // projectIds:'1',
          alarmType: this.eventType1,
          orderBy: this.orderBy,
          status: this.eventType,
          currentPage: this.currentPage,
          size: this.size,
          searchKey: this.searchInput,
        })
        .then((res) => {
          if (res.data) {
            let getDate = res.data.records;
            getDate.forEach((item) => {
              item.eventType = this.eventType;
            });
            this.tableData = getDate;
            this.total = res.data.total;
          }
        });
    },
          handleChange(file, fileList) {
        this.fileList=fileList
        let testFile = file.name
          .substring(file.name.lastIndexOf(".") + 1)
          .toLowerCase();
        // console.log(testFile);
        const isJPG =
          testFile === "jpeg" ||
          testFile === "jpg" ||
          testFile === "png" ||
          testFile === "PNG" ||
          file.type === "JPG";
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.error("上传图片只能是 JPG或者PNG 格式!");
          if (fileList.length > 0) {
            this.fileList.pop();
          } else {
            this.fileList = [];
          }
          return false;
          // this.fileUploadList = []
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1M!");
          if (fileList.length > 0) {
            this.fileList.pop();
          } else {
            this.fileList = [];
          }
           return false;
        }
        return isJPG && isLt2M;
      },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制只能上传9张图片！`);
    },
    open(item) {
      this.dialogVisible = true;
      this.dialogImageUrl = item;
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
  watch: {
    input2(v) {
      if (!v) {
        this.getProjectList();
      }
    },
    dialogFormVisible(v) {
      if (!v) {
        this.$nextTick(() => {
          this.$refs.upload.clearFiles();
        });
      }
    },
  },

  created() {
    this.orderBy = "desc";
    this.userId = JSON.parse(this.$getCookie("userInfo")).userId;
    this.getProjectList();
    this.getAlarmType();
  },
};
</script>

<style lang="less" scoped>
.type {
  width: 8px;
  height: 8px;
  background: #fc5959;
  border: 1px solid #ffd1d1;
  border-radius: 50%;
  margin-right: 8px;
}
.news-item-box {
  display: inline-block;
  position: absolute;
  top: 140px;
  left: 72px;
  .item-box {
    flex-direction: row;
    display: flex;
    margin: 25px 0px 15px 0px;
    .item {
      display: flex;
      margin-right: 20px;
      > div {
        color: #0e223d;
        font-size: 16px;
        cursor: pointer;
        width: 90px;
        text-align: center;
        padding-bottom: 10px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &.active {
        > div {
          font-weight: 600;
          border-bottom: 3px solid;
        }
      }
    }
  }
}
.font-color1 {
  color: #fc5959 !important;
}
.font-color2 {
  color: rgba(51, 204, 141, 1) !important;
}
.font-color0 {
  color: #152139 !important;
}
.right1 {
  display: inline-block;
  float: left;
  width: 50%;
  .el-select {
    width: 80%;
  }
}
.warn {
  width: 100vw;
  height: 100vh;
  background: #f6f6f8;
  // 返回按钮样式
  .return-btn {
float: right;
    margin-right: 52px;
    z-index: 2000;
    margin-top: 72px;
  }
  .warn-list {
    background: #fff;
    padding: 26px 50px;
    margin-top: 50px;
    .title {
      font-size: 18px;
      color: #0e223d;
      letter-spacing: 2px;
      font-weight: 600;
      text-align: left;
      display: inline-block;
    }
    .pro-info {
      // display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      margin-bottom: 28px;
      margin-left: 55%;
      .left {
        font-size: 16px;
        color: #0e223d;
        margin-left: 60%;
        span {
          &:last-of-type {
            font-weight: 600;
          }
        }
      }
      .right {
        display: flex;
        width: 47%;
        .el-input {
          margin: 0px 10px 0px 15px;
        }
        .search {
          margin-right: 20px;
          z-index: 2000;
        }
      }
    }
    /deep/.table-box {
      .el-table {
        background: rgba(0, 0, 0, 0);
        th,
        tr {
          background: rgba(0, 0, 0, 0);
        }
        th {
          > .cell {
            color: #152139;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
          }
        }
        tr {
          td {
            text-align: center;
            font-size: 14px;
            // color: #152139;
          }
        }
        .btn-out-box {
          display: flex;
          justify-content: space-around;
        }
        .btn-box {
          width: 24px;
          height: 24px;
          background: rgba(165, 165, 165, 0.1);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          .iconfont {
            font-size: 12px;
            color: rgba(195, 195, 195, 1);
          }
          &.color1.active {
            background: rgba(224, 122, 20, 0.1);
            .iconfont {
              color: rgba(224, 122, 20, 1);
            }
          }
          &.color2.active {
            background: rgba(20, 96, 224, 0.1);
            .iconfont {
              color: rgba(20, 96, 224, 1);
            }
          }
        }
      }
    }
  }
}
.img-box {
  img {
    width: 120px;
    margin-right: 15px;
  }
}
.el-pagination {
  margin-top: 20px;
  text-align: center;
}
/deep/.el-dialog {
  .el-dialog__title {
    font-weight: 600;
    font-size: 20px;
    color: #152139;
  }
  .name {
    font-size: 26px;
    font-weight: 600;
    color: #152139;
  }
  .eventType {
    font-size: 16px;
    line-height: 27px;
    color: #152139;
    margin-top: 10px;
  }
  .br {
    width: 100%;
    height: 0px;
    border: 1px solid #e4e4e4;
    margin: 20px 0;
  }
  section {
    margin: 8px 0;
    .label {
      font-size: 16px;
      font-weight: 300;
      line-height: 27px;
      color: #152139;
    }
    .info {
      font-size: 16px;
      font-weight: 600;
      line-height: 27px;
      color: #152139;
      &.inline {
        width: 180px;
        display: inline-block;
      }
    }
  }
  .mb10 {
    margin-bottom: 10px;
  }
}
.tips-txt {
  color: red;
  font-size: 14px;
  margin-left: 4px;
}
.font-color1 {
  color: #fc5959 !important;
}
.font-color2 {
  color: rgba(51, 204, 141, 1) !important;
}
.font-color0 {
  color: #152139 !important;
}
</style>
